export default __webpack_public_path__ + "media/images/images/portrait/small/avatar-s-2-829be6747752c56dfc79996e17af6f5e.png";